export const REDIRECT = 302;
export const UNAUTHORIZED = 401;
export const NOT_FOUND_ERROR = 404;
export const CONFLICT_ERROR = 409;
export const INTERNAL_SERVER_ERROR = 500;
